import api from './api';

export async function listSuppliers() {
  const { data } = await api.get('/api/suppliers');
  // Backend now returns { rows, stats }; older callers may expect an array.
  if (data && Array.isArray(data.rows)) return data;
  return { rows: Array.isArray(data) ? data : [], stats: null };
}

export async function uploadProductsCsv(file) {
  const fd = new FormData();
  fd.append('file', file);
  const { data } = await api.post('/api/suppliers/products/upload-csv', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

export async function confirmProductsCsv(rows, created_by = 'CSV Upload') {
  const { data } = await api.post('/api/suppliers/products/upload-csv/confirm', {
    rows,
    created_by,
  });
  return data;
}

export async function fetchSupplierInfo(supplierName) {
  const { data } = await api.get(
    `/api/suppliers/${encodeURIComponent(supplierName)}/info`
  );
  return data;
}

export async function saveSupplierInfo(supplierName, payload, updated_by = 'System') {
  const { data } = await api.put(
    `/api/suppliers/${encodeURIComponent(supplierName)}/info`,
    { ...payload, updated_by }
  );
  return data;
}

export async function saveSupplierInfoById(supplierId, payload, updated_by = 'System') {
  const { data } = await api.put(
    `/api/suppliers/info/${encodeURIComponent(supplierId)}`,
    { ...payload, updated_by }
  );
  return data;
}

export async function fetchCountries() {
  const { data } = await api.get('/api/suppliers/lookup/countries');
  return Array.isArray(data) ? data : [];
}

export async function listSupplierDirectory() {
  const { data } = await api.get('/api/suppliers/list');
  return Array.isArray(data) ? data : [];
}

export async function createSupplierInfo(payload, created_by = 'System') {
  const { data } = await api.post('/api/suppliers/info/create', { ...payload, created_by });
  return data;
}

export async function listSupplierProducts(supplierName, params = {}) {
  const { data } = await api.get(
    `/api/suppliers/${encodeURIComponent(supplierName)}/products`,
    { params }
  );
  return data;
}

export async function updateProduct(id, fields, updated_by = 'System') {
  const { data } = await api.put(`/api/suppliers/products/${encodeURIComponent(id)}`, {
    ...fields,
    updated_by,
  });
  return data;
}

export async function fetchSupplierNames() {
  const { data } = await api.get('/api/suppliers/lookup/supplier-names');
  return Array.isArray(data) ? data : [];
}

export async function fetchDosageForms() {
  const { data } = await api.get('/api/suppliers/lookup/dosage-forms');
  return Array.isArray(data) ? data : [];
}

export async function fetchStrengthUnits() {
  const { data } = await api.get('/api/suppliers/lookup/strength-units');
  return Array.isArray(data) ? data : [];
}

export async function fetchHqCountries() {
  const { data } = await api.get('/api/suppliers/lookup/hq-countries');
  return Array.isArray(data) ? data : [];
}

export async function patchProductStatus(id, status, updated_by = 'System') {
  const { data } = await api.patch(`/api/suppliers/products/${encodeURIComponent(id)}/status`, {
    status,
    updated_by,
  });
  return data;
}

export async function bulkUpdateProducts(ids, fields, updated_by = 'System') {
  const { data } = await api.put(`/api/suppliers/products/bulk`, {
    ids,
    fields,
    updated_by,
  });
  return data;
}

export async function deleteProduct(id, updated_by = 'System') {
  const { data } = await api.delete(`/api/suppliers/products/${encodeURIComponent(id)}`, {
    data: { updated_by },
  });
  return data;
}

export async function bulkUpdateSuppliers(supplier_ids, updates, updated_by = 'System') {
  const { data } = await api.patch('/api/suppliers/bulk', {
    supplier_ids,
    updates,
    updated_by,
  });
  return data;
}
